import React from 'react';
import { TikTokSocialCircle } from 'components/SocialCircle';
import SocialButton, { SocialButtonProps } from './SocialButton';

export interface TikTokButtonProps
  extends Pick<
    SocialButtonProps,
    'disabled' | 'onClick' | 'params' | 'size' | 'tooltip'
  > {}

const TikTokButton: React.FC<TikTokButtonProps> = ({
  disabled,
  onClick,
  size,
  tooltip,
}) => (
  <SocialButton
    icon={<TikTokSocialCircle />}
    label="TikTok"
    {...{ disabled, onClick, size, tooltip }}
  />
);

export default TikTokButton;
